import { useState, useCallback, useEffect } from "react";
import { postSectionToDocumentURL, getSectionTypesAdminURL } from "../../utils/ConstantsURL";
import { toastAlert } from "../../utils/AlertContext";

export function useAddSection(token, id_document, refresh, close) {
  const [formData, setFormData] = useState({
    name_section: "",
    id_type_section: "",
    description: "",
    id_document,
  });

  const [sectionTypes, setSectionTypes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

    useEffect(() => {
    const fetchSectionTypes = async () => {
      try {
        const res = await fetch(getSectionTypesAdminURL(), {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (res.ok) {
          const data = await res.json();
          setSectionTypes(data);
        }
      } catch (err) {
        console.error("Error al cargar tipos de sección:", err);
      }
    };
    fetchSectionTypes();
  }, [token]);

  const resetForm = useCallback(() => {
    setFormData({
      name_section: "",
      id_type_section: "",
      description: "",
      id_document,
    });
    setErrors({});
  }, [id_document]);

  const validateForm = useCallback(() => {
    const newErrors = {};
    if (!formData.name_section.trim()) {
      newErrors.name_section = "El nombre de la sección es obligatorio";
    }
    if (!formData.id_type_section) {
      newErrors.id_type_section = "Selecciona un tipo de sección";
    }
    if (!formData.id_document) {
      newErrors.id_document = "Selecciona un documento";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  }, [formData]);

  const handleSubmit = useCallback(async () => {
    if (!validateForm()) return;

    setLoading(true);
    try {
      const res = await fetch(postSectionToDocumentURL(), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(formData),
      });
      const payload = await res.json();
      if (!res.ok) throw new Error(payload.message);

      refresh();
      close();
      resetForm();
      toastAlert("Sección agregada con éxito", "success", 4000);
    } catch (err) {
      console.error("useAddSection:", err);
      toastAlert(err.message || "Error al agregar la sección", "error", 4000);
    } finally {
      setLoading(false);
    }
  }, [formData, token, refresh, close, validateForm, resetForm]);

  const handleChange = useCallback(
    (e) => {
      const { name, value } = e.target;
      setFormData((fd) => ({ ...fd, [name]: value }));
      if (errors[name]) {
        setErrors((errs) => ({ ...errs, [name]: null }));
      }
    },
    [errors]
  );

  const handleClose = useCallback(() => {
    close();
    resetForm();
  }, [close, resetForm]);

  return {
    formData,
    errors,
    loading,
    sectionTypes,
    handleChange,
    handleSubmit,
    handleClose,
  };
}
